<template>
  <app-layout>
    <div class="max-w-screen-xl mx-auto px-5">
      <h1>Simulator</h1>
      <div class="m-4"></div>
      <label class="el-button el-button--default">
        Upload config.yml file
        <input
          type="file"
          style="display:none"
          ref="fileInput"
          @change="extract($event.target.files)"
        />
      </label>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import scaffoldConfigExtractor from './scaffold-config-extractor';

export default {
  name: 'app-builder-simulator',

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
    }),
  },

  methods: {
    extract(files) {
      if (!files || !files.length) {
        return;
      }

      scaffoldConfigExtractor
        .extract(files[0])
        .then((config) => {
          return this.$store.dispatch(
            'builder/simulate',
            config,
          );
        })
        .then(() => {
          this.$router.push({
            name: 'builder',
            params: {
              scaffoldId: this.scaffold.id,
            },
          });
        })
        .catch((error) => {
          this.$store.dispatch(
            'core/validationError',
            error,
            { root: true },
          );
          this.$refs.fileInput.value = null;
        });
    },
  },
};
</script>

<style></style>
